import { graphql, useStaticQuery } from 'gatsby';
import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import moment from 'moment';
import { Swiper as SwiperType } from 'swiper/types';
import { HomeAgendaPushQuery } from '../../../../graphql-types';
import { HeaderSection } from '../../../components/2.0version/headerSection/HeaderSection';
import { usePageContext } from '../../../hooks/contexts/usePageContext';
import * as styles from './homeAgendaPush.module.scss';
import { CardAgenda } from '../../../components/2.0version/cardAgenda/CardAgenda';
import { HorizontalControls } from '../../../components/2.0version/horizontalControls/HorizontalControls';
import { LocaleLink } from '../../../components/2.0version/localeLink/LocaleLink';
import { Button } from '../../../components/2.0version/button/Button';
import { URLS } from '../../../../constants';

export const minDate = (ouvertures) => {
  const initial = 5000000000;
  return ouvertures?.reduce((a, b) => {
    if (moment(b?.date_fin).unix() - moment().unix() > 0)
      return Math.min(a, moment(b?.date_debut).unix());
    return a;
  }, initial);
};

export const sortOtsAgenda = (otList) =>
  otList?.sort((a, b) => minDate(a?.ouvertures) - minDate(b?.ouvertures));

export const HomeAgendaPush = () => {
  const { lang } = usePageContext();
  const { sanityHomePage, allIngenieOt, sanityTranslations } =
    useStaticQuery<HomeAgendaPushQuery>(QUERY);
  const [swiper, setSwiper] = useState<SwiperType>();
  const otList = allIngenieOt.nodes;

  const OtsFiltered = sortOtsAgenda(otList);

  const header = sanityHomePage?.headerAgenda;

  return (
    <section className={styles.wrapper}>
      <HeaderSection
        title={header?._rawTitle?.[lang]}
        description={header?._rawDescription?.text?.[lang]}
      />
      <div className={styles.fullWidth}>
        <Swiper onSwiper={(e) => setSwiper(e)} slidesPerView="auto" spaceBetween={16}>
          {OtsFiltered?.map((ot) => (
            <SwiperSlide key={`home-agenda-${ot.id}`} className={styles.slide}>
              <CardAgenda ot={ot} />
            </SwiperSlide>
          ))}
        </Swiper>
        <HorizontalControls swiper={swiper as SwiperType} />
      </div>
      <div className={styles.buttonWrapper}>
        <Button>
          <LocaleLink to={URLS.agenda.url}>
            {sanityTranslations?._rawGoToAgendaButton[lang]}
          </LocaleLink>
        </Button>
      </div>
    </section>
  );
};

const QUERY = graphql`
  query HomeAgendaPush {
    sanityHomePage {
      headerAgenda {
        _rawDescription
        _rawTitle
      }

      agendaItems {
        code
        _key
      }
    }
    sanityTranslations {
      _rawGoToAgendaButton
    }
    allIngenieOt(filter: { key: { eq: "Y" } }, limit: 10) {
      nodes {
        ...cardOtFragment
        ...wishListFragment
        localisation {
          adresse {
            ville
          }
        }
        pictosPartners {
          url
          alt
        }
        ouvertures {
          date_debut
          date_fin
        }
        criteres210 {
          histoirePatrimoine
          art
          musique
          gastronomieEtVins
          sport
          nature
          soiree
          jeunePublic
          plusDeRdv
        }
      }
    }
  }
`;
